export default __webpack_public_path__ + "static/media/roadmap5.55b71ef7.png";